document.addEventListener("DOMContentLoaded", function() {
    var lazyloadImages;    
  
    if ("IntersectionObserver" in window) {
      lazyloadImages = document.querySelectorAll(".lazy");
      var imageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var image = entry.target;
            image.classList.remove("lazy");
            imageObserver.unobserve(image);
          }
        });
      });
  
      lazyloadImages.forEach(function(image) {
        imageObserver.observe(image);
      });
    } else {  
      var lazyloadThrottleTimeout;
      lazyloadImages = document.querySelectorAll(".lazy");
      
      function lazyload () {
        if(lazyloadThrottleTimeout) {
          clearTimeout(lazyloadThrottleTimeout);
        }    
  
        lazyloadThrottleTimeout = setTimeout(function() {
          var scrollTop = window.pageYOffset;
          lazyloadImages.forEach(function(img) {
              if(img.offsetTop < (window.innerHeight + scrollTop)) {
                img.src = img.dataset.src;
                img.classList.remove('lazy');
              }
          });
          if(lazyloadImages.length == 0) { 
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      }
  
      document.addEventListener("scroll", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
  });
  
  /* Whenever mobile checking is needed:
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() > 798) { 
    } */
  
  /* NEEDS TO BE ADDED TO APP "Add To Cart & Checkout BOOSTER PRO" 
       var barToMove = $('#satcb_bar').detach();
      barToMove.appendTo('#my-page');
  */
  
  let searchPanel = document.querySelector("#searchPanel");
  let firstBar = document.querySelector("#first_bar");
  let secondBar = document.querySelector("#second_bar");
  let announcementbar1 = document.querySelector("#announcement_bar");
  let second_bar_mobile = document.querySelector("#second_bar_mobile");
  let toHideForSearch1 = document.querySelector("#toHideForSearch1");
  let toHideForSearch2 = document.querySelector("#toHideForSearch2");
  let searchPanelMobile = document.querySelector("#searchPanelMobile");
  let toHideForSearch3 = document.querySelector("#toHideForSearch3");
  let toHideForSearch4 = document.querySelector("#toHideForSearch4");
  let filterCollection = document.querySelector(".filters_cta_wrapper");
  let sezzle_icon = document.querySelector('.sezzle-info-icon');
  let currentURL = window.location.href;
  
  document.addEventListener("scroll", adjustAnnouncementbarTop);
  document.addEventListener("resize", adjustAnnouncementbarTop);
  document.addEventListener("scroll", adjustSecondBarTop);
  document.addEventListener("resize", adjustSecondBarTop);

  // document.addEventListener("scroll", adjustFilterCollectionTop);
  // document.addEventListener("resize", adjustFilterCollectionTop);
  
  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }
  
  function waitForElement(selector) {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }
  
      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
  
  function getWindowWidth() {
    return $(window).width();
  }

  function getWindowHeight() {
    return document.getElementsByTagName('body')[0].clientHeight;
  }
  
  function openRewardsWidget() {
    $(".ssw-reward-tab").attr("onclick", "void(0);");
    $(".ssw-reward-tab").click();
  }
  
  function openSearchPanel() {
    if (searchPanel.style.display === "none") {
      searchPanel.style.display = "block";
      toHideForSearch1.style.display = "none";
      toHideForSearch2.style.display = "none";
      $("#search_box_desktop").focus();
    } else {
      searchPanel.style.display = "none";
      toHideForSearch1.style.display = "block";
      toHideForSearch2.style.display = "block";
    }
  }
  
  function openSearchPanelMobile() {
    if (searchPanelMobile.style.display === "none") {
      searchPanelMobile.style.display = "block";
      toHideForSearch3.style.display = "none";
      toHideForSearch4.style.display = "none";
      second_bar_mobile.style.display = "none";
      $("#search_box_mobile").focus();
    } else {
      searchPanelMobile.style.display = "none";
      toHideForSearch3.style.display = "block";
      toHideForSearch4.style.display = "block";
      second_bar_mobile.style.display = "flex";
    }
  }
  
  function openWishlistPanel() {
    $("#ssw-fave-side-button").click();
  }
  
  function openReviewsPanel() {
    if ($(".ssw-reviews-widget").hasClass("open")) {
      $(".review-close-top").click();
    }
  
    $(".ssw-reviews-widget").toggleClass("open");
  }
  
  function adjustAnnouncementbarTop() {
    if (announcementbar1.classList.contains("announcement_sticky")) {
      announcementbar1.style.top = firstBar.clientHeight + secondBar.clientHeight;
    } else {
      announcementbar1.style.top = 0;
    }
  }
  
  function adjustSecondBarTop() {
    if (secondBar.classList.contains("nav-sticky")) {
      secondBar.style.top = firstBar.clientHeight;
    } else {
      secondBar.style.top = 0;
    }
  }
  
  
  function adjustFilterCollectionTop() {
    if (filterCollection.classList.contains("nav-sticky")) {
      filterCollection.style.top = firstBar.clientHeight + secondBar.clientHeight + announcementbar1.clientHeight;
    } else {
      filterCollection.style.top = 0;
    }
  }
  
  
  function addBreaklines() {
    if (getWindowWidth() >= 767 || getWindowWidth() <= 480) {
      const shapeTitleContainer = document.querySelectorAll(
        ".shape_and_title_container"
      )[0];
      for (const title of document.querySelectorAll("div[itemprop='name']")) {
        if (
          title.textContent.includes("Cards") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace("Cards", "<br>Cards");
        }
        if (
          title.textContent.includes("Hibiscus and Hummingbird") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Hibiscus and Hummingbird",
            "Hibiscus and <br>Hummingbird"
          );
        }
        if (
          title.textContent.includes("Over The Rainbow (Large Version)") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Over The Rainbow (Large Version)",
            "Over The Rainbow <br>(Large Version)"
          );
        }
        if (
          title.textContent.includes("Twisted Blossom (Large Version)") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Twisted Blossom (Large Version)",
            "Twisted Blossom <br>(Large Version)"
          );
        }
        if (
          title.textContent.includes("Corgi Nights (Van Gogh Edition)") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Corgi Nights (Van Gogh Edition)",
            "Corgi Nights (Van <br>Gogh Edition)"
          );
        }
        if (
          title.textContent.includes("Grumpy Cat (Van Gogh Edition)") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Grumpy Cat (Van Gogh Edition)",
            "Grumpy Cat (Van <br>Gogh Edition)"
          );
        }
        if (
          title.textContent.includes(
            "Never Saw Golden Gate (Van Gogh Edition)"
          ) &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Never Saw Golden Gate (Van Gogh Edition)",
            "Never Saw Golden Gate (Van <br>Gogh Edition)"
          );
        }
        if (
          title.textContent.includes("Mary Poppins (Jolly Holiday)") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Mary Poppins (Jolly Holiday)",
            "Mary Poppins <br>(Jolly Holiday)"
          );
        }
        if (
          title.textContent.includes("Victorian Mansion Grounds") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Victorian Mansion Grounds",
            "Victorian Mansion <br>Grounds"
          );
        }
        if (
          title.textContent.includes("The Old Waterway Cottage") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "The Old Waterway Cottage",
            "The Old Waterway <br>Cottage"
          );
        }
        if (
          title.textContent.includes("Porta Rossa Al Tramonto") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Porta Rossa Al Tramonto",
            "Porta Rossa <br>Al Tramonto"
          );
        }
        if (
          title.textContent.includes("English Garden with Trellis") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "English Garden with Trellis",
            "English Garden <br>with Trellis"
          );
        }
        if (
          title.textContent.includes("La Porta Rossa Sulla Salita") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "La Porta Rossa Sulla Salita",
            "La Porta Rossa <br>Sulla Salita"
          );
        }
        if (
          title.textContent.includes("Waterlilies of Summer") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Waterlilies of Summer",
            "Waterlilies of <br>Summer"
          );
        }
        if (
          title.textContent.includes("I Vasi Dietro La Grata") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "I Vasi Dietro La Grata",
            "I Vasi Dietro <br>La Grata"
          );
        }
        if (
          title.textContent.includes("Cottage on the Water") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Cottage on the Water",
            "Cottage on <br>the Water"
          );
        }
        if (
          title.textContent.includes("Un Soggiorno A Venezia") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Un Soggiorno A Venezia",
            "Un Soggiorno <br>A Venezia"
          );
        }
        if (
          title.textContent.includes("Balcony Overlooking Vineyards") &&
          shapeTitleContainer.offsetWidth - title.offsetWidth < 54
        ) {
          title.innerHTML = title.innerHTML.replace(
            "Balcony Overlooking Vineyards",
            "Balcony Overlooking <br>Vineyards"
          );
        }
      }
    }
  }
  
  function getAllUrlParams(url) {
    var queryString = url ? url.split("?")[1] : window.location.search.slice(1);
    var obj = {};
    if (queryString) {
      queryString = queryString.split("#")[0];
      var arr = queryString.split("&");
      for (var i = 0; i < arr.length; i++) {
        var a = arr[i].split("=");
        var paramName = a[0];
        var paramValue = typeof a[1] === "undefined" ? true : a[1];
        paramName = paramName.toLowerCase();
        if (typeof paramValue === "string") paramValue = paramValue.toLowerCase();
        if (paramName.match(/\[(\d+)?\]$/)) {
          var key = paramName.replace(/\[(\d+)?\]/, "");
          if (!obj[key]) obj[key] = [];
  
          if (paramName.match(/\[\d+\]$/)) {
            var index = /\[(\d+)\]/.exec(paramName)[1];
            obj[key][index] = paramValue;
          } else {
            obj[key].push(paramValue);
          }
        } else {
          if (!obj[paramName]) {
            obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === "string") {
            obj[paramName] = [obj[paramName]];
            obj[paramName].push(paramValue);
          } else {
            obj[paramName].push(paramValue);
          }
        }
      }
    }
    return obj;
  }
  
  waitForElement(".sezzle-button-text").then((element) => {
    let klarnaElement = document.createElement("img");
    let shopPayElement = document.createElement("img");
    let shopPayImageSrc =
      "https://cdn.shopify.com/s/files/1/0061/0687/3922/files/ShopPay.svg?v=1637031494";
    let klarnaImageSrc =
      "//cdn.shopify.com/shopifycloud/shopify/assets/payment_icons/klarna-389801c6056cb5600b4f05f72ebc2c58e4947688c6c4f5e6ccea41f7973d3a28.svg";
    klarnaElement.classList.add("payment_image", "klarna");
    shopPayElement.classList.add("payment_image", "shopPay");
    klarnaElement.setAttribute("src", klarnaImageSrc);
    shopPayElement.setAttribute("src", shopPayImageSrc);
    element.append(shopPayElement);
    element.append(klarnaElement);
  });
  
  waitForElement(".filters_cta_wrapper").then((element) => {
    document.addEventListener("scroll", adjustFilterCollectionTop);
    document.addEventListener("resize", adjustFilterCollectionTop);
  });
  
  waitForElement(".sezzle-logo").then((element) => {
    let breakline = document.createElement("br");
    document
      .querySelector(".sezzle-button-text")
      .insertBefore(breakline, element);
  });
  
  waitForElement("#fsb_container").then((element) => {
    var shipping_bar = document.querySelector("#fsb_bar");
    var first_bar_inner = document.querySelector("#first_bar_inner");
    first_bar_inner.innerHTML = shipping_bar.innerHTML;
  });
  
  waitForElement("#removeFile").then((element) => {
    element.style.display = "block";
  });
  
  waitForElement(".ssw-fileupload-exists.btn.button").then((element) => {
    element.style.display = "block";
  });
  
  waitForElement(".ssw-fileupload-new.btn.button").then((element) => {
    element.style.display = "block";
  });
  
  waitForElement(".ssw-own-profile").then((element) => {
    document.querySelector("#custom-past-orders").style.display = "block";
  });
  
  waitForElement(".ssw-profile").then((element) => {
    $(".ssw-sm-twitter").html(
      '<i class="ssw-icon-twitter"></i>' + $(".ssw-sm-twitter").text().substr(1)
    );
  });
  
  waitForElement("#shopify-section-product-recommendations .lazy").then((element) => {
    document.querySelectorAll(".lazy").forEach(function(img) {
      img.classList.remove('lazy');
    });
  });
  
  $("p, img").on("contextmenu", function (e) {
    return false;
  });
  
  $("p, img").bind("cut copy paste", function (e) {
    e.preventDefault();
  });
  
  document.addEventListener(
    "DOMContentLoaded",
    () => {
      new Mmenu("#my-menuNav", {
        slidingSubmenus: false,
        scrollBugFix: {
          fix: false,
        },
        extensions: ["pagedim-black"],
        navbars: [
          {
            position: "top",
            content: ["close"],
          },
        ] /* navbars */,
      }); /* new Mmenu */
    } /* Document Loaded */
  ); /* document.addEventListener("DOMContentLoaded") */
  
  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("add_to_cart")) {
      setTimeout(function () {
        var shipping_bar = document.querySelector("#fsb_bar");
        var first_bar_inner = document.querySelector("#first_bar_inner");
        first_bar_inner.innerHTML = shipping_bar.innerHTML;
      }, 1000);
    }
  
  //   if (event.target.classList.contains("usf-load-more")) {
  //     setTimeout(function () {
  //       addBreaklines();
  //     }, 5000);
  //   }
  
    if (event.target.classList.contains("dropdown_diamonds")) {
      $(".ssw-reward-tab").click();
    }
  
    if (event.target.classList.contains("mobile_dropdown_diamonds")) {
      $(".ssw-reward-tab").click();
    }
    
    //IMPROVE WITH TOGGLE CLASS
    
    if (event.target.classList.contains("mobile_filters_cta")) {
      if ($("#filters_lightbox").css("visibility") == "hidden") {
          $("#filters_lightbox").css("visibility", "visible");
          $("body").addClass("overflow_hidden");
        } else {
        $("#filters_lightbox").css("visibility", "hidden");
      }
    }
  
    if (event.target.classList.contains("drill_question_mark")) {
      if ($("#drill_lightbox").css("visibility") == "hidden")
        $("#drill_lightbox").css("visibility", "visible");
      else $("#drill_lightbox").css("visibility", "hidden");
    }
  
    if (event.target.classList.contains("transaction_question_mark")) {
      if ($("#transaction_lightbox").css("visibility") == "hidden")
        $("#transaction_lightbox").css("visibility", "visible");
      else $("#transaction_lightbox").css("visibility", "hidden");
    }
  
    if (event.target.classList.contains("diamonds_question_mark")) {
      if ($("#diamonds_lightbox").css("visibility") == "hidden")
        $("#diamonds_lightbox").css("visibility", "visible");
      else $("#diamonds_lightbox").css("visibility", "hidden");
    }
  
    if (event.target.classList.contains("difficulty_question_mark")) {
      if ($("#difficulty_lightbox").css("visibility") == "hidden")
        $("#difficulty_lightbox").css("visibility", "visible");
      else $("#difficulty_lightbox").css("visibility", "hidden");
    }
  
    if (event.target.classList.contains("confetti_question_mark")) {
      if ($("#confetti_lightbox").css("visibility") == "hidden")
        $("#confetti_lightbox").css("visibility", "visible");
      else $("#confetti_lightbox").css("visibility", "hidden");
    }
  
    if (event.target.classList.contains("v1_question_mark")) {
      if ($("#v1_lightbox").css("visibility") == "hidden")
        $("#v1_lightbox").css("visibility", "visible");
      else $("#v1_lightbox").css("visibility", "hidden");
    }
        
    if (event.target.classList.contains("filters_close_toggle")) {
      $("#filters_lightbox").css("visibility", "hidden");
      $("body").removeClass("overflow_hidden");
    }
  
    if (event.target.classList.contains("close_toggle")) {
      $("#diamonds_lightbox").css("visibility", "hidden");
      $("#drill_lightbox").css("visibility", "hidden");
      $("#v1_lightbox").css("visibility", "hidden");
      $("#transaction_lightbox").css("visibility", "hidden");
      $("#difficulty_lightbox").css("visibility", "hidden");
      $("#confetti_lightbox").css("visibility", "hidden");
      $("body").removeClass("overflow_hidden");
    }
  }); /* document.addEventListener("click") */
  
  $(document).ready(function () {
    /* Ready */
  
    document.getElementsByTagName("html")[0].style.visibility = "visible";
    $('.product-custom-kit-new-template #addtocart').prop("disabled", true);
  
    if (getWindowWidth() >= 798) {
      var timeToStick = 250;
    } else {
      var timeToStick = 360;
      $("#product_main_container").removeClass(
        "thumbnail_position--left-thumbnails"
      );
      $("#product_main_container").addClass("thumbnail_position--bottom");
    }
  
    var s = $("#second_bar");
    var pos = s.position();
    $(window).scroll(function () {
      var windowpos = $(window).scrollTop();
      if ((windowpos >= pos.top) & (windowpos <= timeToStick)) {
      }
  
      if (windowpos >= timeToStick) {
        document.querySelector("#second_bar_desktop .logo_img").src =
          "https://cdn.shopify.com/s/files/1/0061/0687/3922/files/SVG_DREAMER_DESIGNS_TYPO_LOGO_SVG.svg?v=1613010189";
        document
          .querySelector("#first_bar")
          .classList.add("animated", "fadeIn", "nav-sticky");
        document
          .querySelector("#second_bar")
          .classList.add("animated", "fadeIn", "nav-sticky");
        document
          .querySelector(".announcementBar")
          .classList.add("animated", "fadeIn", "announcement_sticky");
        document
          .querySelector(".disclosure__list")
          .classList.add("animated", "fadeIn", "move__country__list");
        if (getWindowWidth() <= 1024 && !!filterCollection) {
            filterCollection.classList.add("animated", "fadeIn", "nav-sticky");
        }
      } else {
        document.querySelector("#second_bar_desktop .logo_img").src =
          "https://cdn.shopify.com/s/files/1/0061/0687/3922/files/SVG_DREAMER_DESIGNS_FULL_LOGO_SVG.svg?v=1613010189";
        document
          .querySelector("#first_bar")
          .classList.remove("nav-sticky", "animated", "fadeIn");
        document
          .querySelector("#second_bar")
          .classList.remove("nav-sticky", "animated", "fadeIn");
        document
          .querySelector(".announcementBar")
          .classList.remove("animated", "fadeIn", "announcement_sticky");
        document
          .querySelector(".disclosure__list")
          .classList.remove("animated", "fadeIn", "move__country__list");
        announcementbar1.style.top = 0;
        if (getWindowWidth() <= 1024 && !!filterCollection) {
            filterCollection.classList.remove("nav-sticky", "animated", "fadeIn");
        }
      }
  
      if ($(window).scrollTop() > 118) {
        $(".rmz-notification").css("display", "block");
        $(".ssw-reward-tab").css("display", "block");
      }
  
      if ($(window).scrollTop() == 0) {
        $(".rmz-notification").css("display", "none");
        $(".ssw-reward-tab").css("display", "none");
      }
  
      let div = document
        .getElementsByClassName("klaviyo-form-JsvEZs")[0]
        .getElementsByClassName("needsclick")[3];
      if (div) {
        div.style.flexDirection = "";
      }
    }); /* $(window).scroll() */
  
    if (getAllUrlParams(currentURL).rewards) {
      setTimeout(function () {
        $(".ssw-reward-tab").attr("onclick", "void(0);");
        $(".ssw-reward-tab").click(); //Intended URL variable is 'https://dreamerdesigns.com/?rewards=open';
      }, 1000);
    }
  
    if (getAllUrlParams(currentURL).st_intent) {
      setTimeout(function () {
        $(".ssw-reward-tab").attr("onclick", "void(0);");
        $(".ssw-reward-tab").click(); //Backwards compatible with Smile.io functionality
      }, 1000);
    }
  
    if (getAllUrlParams(currentURL).resume_scrolling) {
      setTimeout(function () {
        $("html, body").animate(
          { scrollTop: $(".thumbnail:nth-child(18)").offset().top },
          "slow"
        );
      }, 1750);
    }
  
    /* CHANGE HOMEPAGE VIDEO TO NOT AUTOPLAY BUT KEEP DESIGN FOR THUMBNAIL */
    $(".index-sections div.mediaWrapper iframe").prop(
      "src",
      "//www.youtube.com/embed/ZEDj8SdjFYc?&amp;autoplay=0&amp;loop=0&amp;rel=0&amp;hd=1&amp;showinfo=0&amp;color=white&amp;controls=0"
    );
  
    $(".ssw-reward-tab").attr("onclick", "void(0);");
  
    $(".ssw-instagram-home h2").text("Share Your Masterpiece");
  
    $("#ssw-topauth .ssw-tprofile").addClass("ssw-dropdown-copy");
  
    $("#ssw-topauth .ssw-tprofile ul.ssw-dropdown-menu").addClass(
      "menuCopy animated fadeIn"
    );
  
    $(".fade_on_ready").fadeIn("low");
  
    setTimeout(function () {
      $(".fade_on_ready_timer").fadeIn("low");
  
      $(".ssw-control-label:contains('Picture')").html(
        "Picture <br><span style='font-weight:300;'>Recommended size is 96x96, squared image in .jpg format</span>"
      );
    }, 2000);
  
    setTimeout(function () {
        !!sezzle_icon && sezzle_icon.removeAttribute('disabled');
      $(".wishlist_heart_fading").fadeIn("low");
      addBreaklines();
    }, 5000);
  
    if (!getWindowWidth() >= 798) {
      var moveToSecondLine = "With";
      $(".headline_1572682429032").html(
        $(".headline_1572682429032 ")
          .html()
          .replace(moveToSecondLine + " ", moveToSecondLine + "<br>")
      );
    }
  }); /* END READY */
  
  sswRun(function () {
    $(document).ready(function () {
      
      setTimeout(function () {
        $('.ssw-faveiticon').show(); // Fix for wishlist icon from showing before the icon loaded
      }, 3000); //setTimeout
      
      var revTimer = setInterval(function () {
        $(".ssw-reviews-container").removeAttr("style");
        clearInterval(revTimer);
      }, 1000);
  
      var interval = setInterval(function () {
        if (ssw("#ssw-widget-review-bar .ssw-reviews-wlist").length) {
          ssw("#ssw-widget-review-bar .ssw-reviews-wlist").addClass("closed-tab");
          clearInterval(interval);
        }
      }, 1000);
  
      var intervalID = setInterval(function() {
          if(ssw('#ssw-widget-review-bar').length) {
              if(ssw('#ssw-widget-review-bar').css('left') == '0px') {
                var lengthReviewTab = -ssw('#ssw-widget-review-bar').width()
                ssw('#ssw-widget-review-bar').css('left', `${lengthReviewTab}px`)
            }
            clearInterval(intervalID);
          }
        }, 1000);
  
//       if (isIOS()) {
//         setTimeout(function () {
//           var e = Ssw.gwAssetsManifestLoader;
//           e.requireByKey("lib.photoswipe.js", "SCRIPT"),
//             e.requireByKey("review.main.css", "STYLE").then(function () {
//               e.requireByKey("review.main.js", "SCRIPT");
//               var s = [];
//               s.push(
//                 loadWidgetTo(ssw("#ssw-review-widget-content"), {
//                   module: "recommendation",
//                   name: "reviewsPopup",
//                   metafield_key: "review_tab",
//                 })
//               ),
//                 Promise.all(s).then(function () {
//                   e.requireByKey("review.popup.main.js", "SCRIPT");
//                 });
//             });
//         }, 3000); //setTimeout
//       }
      
    }); //Ready
  }); //sswRun
  
  window.formatToK = function formatThousandToK(num) {
    return Math.abs(num) > 999
      ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
      : Math.sign(num) * Math.abs(num);
  };
  
  $(window).bind("load", function () {
    var selector4 = "#ssw-widget-review-bar";
    var waitForEl4 = function (selector4, callback) {
      if (jQuery(selector4).length) {
        callback();
      } else {
        setTimeout(function () {
          waitForEl4(selector4, callback);
        }, 1000);
      }
    };
  
    // waitForEl4(selector4, function () {
    //   $(selector4).prepend(
    //     '<span class="review-button review-tab-toggle"><i class="fas fa-star"></i> REVIEWS</span>'
    //   );
    // });
  
    if (window.location.pathname != "/") {
      var waitForEl = function (selector, callback) {
        if (jQuery(selector).length) {
          callback();
        } else {
          setTimeout(function () {
            waitForEl(selector, callback);
          }, 100);
        }
      };
  
      var waitForEl2 = function (selector2, callback) {
        if (jQuery(selector2).length) {
          callback();
        } else {
          setTimeout(function () {
            waitForEl(selector2, callback);
          }, 100);
        }
      };
  
      var waitForEl3 = function (selector3, callback) {
        if (jQuery(selector3).length) {
          callback();
        } else {
          setTimeout(function () {
            waitForEl(selector3, callback);
          }, 100);
        }
      };
  
      var selector = ".ssw-reward-tab";
      var selector2 = ".rmz-notification";
      var selector3 = ".review-button";
  
      waitForEl(selector, function () {
        $(selector).addClass("hideme");
      });
      waitForEl(selector2, function () {
        $(selector2).addClass("hideme");
      });
      waitForEl(selector3, function () {
        $(selector3).addClass("hideme");
      });
    }
  });
  
  /* Observer for changes to body tag - will hide/show Reviews-tab */
  
  var elemToObserve = document.getElementsByTagName("BODY")[0];
  var prevClassState = elemToObserve.classList.contains("mm-wrapper_opened");
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName == "class") {
        var currentClassState =
          mutation.target.classList.contains("mm-wrapper_opened");
        if (prevClassState !== currentClassState) {
          prevClassState = currentClassState;
          if (currentClassState) {
            $(".review-button").addClass("hideme");
          } else {
            $(".review-button").removeClass("hideme");
          }
        }
      }
    });
  });
  observer.observe(elemToObserve, { attributes: true });
  
  
  /* Start from app.js */

  //Sidebar top
  var _toggleSidebarBlocks = function ($toggle) {
    const dataAttribute = $toggle.attr("data-reference");
    const target = document.querySelector(
      `[data-reference="child_${dataAttribute}"]`
    );
    if ($(target).is(":visible")) {
      $(target).hide();
      $(target).parents(".menu_links_container").hide();
      // $toggle.children('span').html('+');
      $toggle.attr("aria-expanded", false);
      $($toggle).parents(".box").removeClass("lighter_purple_background");
    } else {
      $(target).css( "display", "flex" );
      $(target).parents(".menu_links_container").show();
      // $toggle.children('span').html('-');
      $toggle.attr("aria-expanded", true);
      $($toggle).parents(".box").addClass("lighter_purple_background");
    }
  };

  var _toggleSidebarMenus = function ($toggle) {
    const dataAttribute = $toggle.attr("data-reference");
    const target = document.querySelector(
      `[data-reference="child_${dataAttribute}"]`
    );
    $(target).slideToggle();
    $toggle.toggleClass("active");
    $toggle.attr(
      "aria-expanded",
      $toggle.attr("aria-expanded") == "true" ? "false" : "true"
    );
  };

  $(document).on("click", ".sidebar_top .menu-toggle", function (e) {
    _toggleSidebarMenus($(this));
  });

  var _sidebarTouched = false;
  $(document).on("touchstart", ".sidebar_top .toggle", function (e) {
    //if ($(window).width() <= 798 || $(this).parents('.sidebar').hasClass('toggle-all--true'))
    if ($(this).parents(".sidebar_top").hasClass("toggle-all--true")) {
      var $toggle = $(this);
      _toggleSidebarBlocks($toggle);
      _sidebarTouched = true;
      e.preventDefault();
      return false;
    }
  });

  $(document).on("click", ".sidebar_top .toggle", function (e) {
    //if ($(window).width() <= 798 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
    //if ($(".sidebar_top").length > 0) {
      $(".sidebar_top .toggle_list").each(function () {
        $(this).hide();
      });
      $(".sidebar_top .menu_links_container").each(function () {
        $(this).hide();
      });
      $(".sidebar_top .toggle").each(function () {
        $(this).attr("aria-expanded", false);
        $(this).parents(".box").removeClass("lighter_purple_background");
      });
    //}

    if ($(this).parents(".sidebar_top").hasClass("toggle-all--true")) {
      var $toggle = $(this);
      if (!_sidebarTouched) {
        _toggleSidebarBlocks($toggle);
        e.preventDefault();
        return false;
      }
    }
  });

  $(".sidebar_top .toggle_list").each(function () {
    if ($(this).is(":visible")) {
      $(this).prev(".toggle").attr("aria-expanded", true);
    }
  });

  
  //Sidebar default
  var toggleSidebarBlocks = function ($toggle) {
    if ($toggle.next("ul").is(":visible")) {
      $toggle.next("ul").hide();
      // $toggle.children('span').html('+');
      $toggle.attr("aria-expanded", false);
    } else {
      $toggle.next("ul").css( "display", "flex" );
      // $toggle.children('span').html('-');
      $toggle.attr("aria-expanded", true);
    }
  };

  var toggleSidebarMenus = function ($toggle) {
    var $content = $toggle.next("ul");
    $content.slideToggle();
    $toggle.toggleClass("active");
    $toggle.attr(
      "aria-expanded",
      $toggle.attr("aria-expanded") == "true" ? "false" : "true"
    );
  };

  $(document).on("click", ".default .menu-toggle", function (e) {
    toggleSidebarMenus($(this));
  });

  var sidebarTouched = false;
  $(document).on("touchstart", ".toggle", function (e) {
    //if ($(window).width() <= 798 || $(this).parents('.sidebar').hasClass('toggle-all--true'))
    if ($(this).parents(".default.sidebar").hasClass("toggle-all--true")) {
      var $toggle = $(this);
      toggleSidebarBlocks($toggle);
      sidebarTouched = true;
      e.preventDefault();
      return false;
    }
  });
  $(document).on("click", ".default .toggle", function (e) {
    //if ($(window).width() <= 798 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
    if ($(this).parents(".default.sidebar").hasClass("toggle-all--true")) {
      var $toggle = $(this);
      if (!sidebarTouched) {
        toggleSidebarBlocks($toggle);
        e.preventDefault();
        return false;
      }
    }
  });

  $(".default .toggle_list").each(function () {
    if ($(this).is(":visible")) {
      $(this).prev(".toggle").attr("aria-expanded", true);
    }
  });


  
    $('body').on('change', '#tag_filter, #sort-by', function() {
        var sortValue = $('#sort-by').val();
        var filterValue = $('#tag_filter').val();

        Shopify.queryParams.sort_by = sortValue;
        sortUrl = $.param(Shopify.queryParams);

        if (sortValue && filterValue){
          window.location = filterValue + '?sort_by=' + sortValue;
        } else if (sortValue && !filterValue) {
          window.location = '?' + sortUrl;
        } else if (!sortValue && filterValue){
          window.location = filterValue;
        }
    });

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

/* End from app.js */